<template>
    <div class="modal fade" tabindex="-1" aria-modal="true" role="dialog" id="modalVideo">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div class="modal-content" style="border-radius: 20px;">
                <div class="modal-body" style="padding: 0;">
                    <video id="videoId" controls controlsList="nodownload" style="width: 100%;" class="embed-responsive-item"> 
                        <source :src="url" ref="video" type="video/mp4">
                    </video>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'VideoModal',
    props: ['full_url'],
    data() {
        return {
            url: "",
        };
    },  
    mounted: function () {
        this.url = this.full_url;
        document.addEventListener("keydown", (e) => {
            if (e.keyCode == 27) {
                var modal = document.getElementById('modalVideo');
                if (e.target == modal) {
                    var file = document.getElementById('videoId');
                    if (file) {
                        file.pause();
                    }
                }
            }
        });
        document.addEventListener("click", (e) => {
            var modal = document.getElementById('modalVideo');
            if (e.target == modal) {
                var file = document.getElementById('videoId');
                if (file) {
                    file.pause();
                }
            }
        });

    },
}
</script>


